export const blockIconsPrivacyandsecurityKeyVisualizerNew = (
	<span className='material-symbols-outlined'>key_visualizer</span>
);
